import httpClient from "./httpClient"; // Adjust path as needed

const AnnouncementMemberService = {
  async activateAll(announcementId, teamId) {
    const response = await httpClient.post("/announcement-member/activate", {
      teamId,
      announcementId
    });
    return response.data;
  },

  async findById(announcementId) {
    const response = await httpClient.get(`/announcement-member/get-by-announcement/${announcementId}`);
    return response.data;
  },

  async update(id, entity) {
    const response = await httpClient.put(`/announcement-member/${id}`, entity);
    return response.data;
  },

  async updateRoles(id, roles) {
    const response = await httpClient.put(`/announcement-member/${id}/roles`, { roles });
    return response.data;
  },

  async assignMembers(announcementId, teamMemberIds) {
    const response = await httpClient.post("/announcement-member/assign", {
      announcementId,
      teamMemberIds
    });
    return response.data;
  }
};

export default AnnouncementMemberService;
